export const getWebhooks = state => state.marketplace.additionalResources.webhookResource.webhooks.data;
export const isLoadingWebhooks = state => state.marketplace.additionalResources.webhookResource.webhooks.loading;